import dayjs from 'dayjs';
import { Component, Vue, Ref, Prop } from "vue-property-decorator";

@Component({
  components: {

  }
})
export default class Alarm extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_material_ware_out_code'),
        dataIndex: 'orderCode',
        key: 'orderCode',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_out_name'),
        dataIndex: 'orderName',
        key: 'orderName',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_business_delivery_type'),
        dataIndex: 'stockOutType',
        key: 'stockOutType',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_out_stockOutTime'),
        dataIndex: 'stockOutTime',
        key: 'stockOutTime',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '' }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_out_stockOutUser'),
        dataIndex: 'stockOutUser',
        key: 'stockOutUser',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findUser(value) }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_out_distributeUser'),
        dataIndex: 'distributeUser',
        key: 'distributeUser',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findUser(value) }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_out_planCode'),
        dataIndex: 'planCode',
        key: 'planCode',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_out_produceDept'),
        dataIndex: 'produceDept',
        key: 'produceDept',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findDept(value) }
            </span>
          )
        },
      }
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<string>;
  @Prop({ default: () => [] }) readonly employeesList: Array<any>;
  @Prop({ default: () => [] }) readonly listAllTree: Array<any>;
  @Prop({ default: ""}) readonly current: String;
  @Prop({ default: ""}) readonly pageSize: String;
  @Prop({ default: ""}) readonly total: String;
  @Prop({ default: false }) readonly loading: Boolean;
  @Prop({ default: 300 }) readonly height: Number;
  @Prop({ default: ""}) readonly selectId: String;
  @Prop({ default: () => [] }) readonly selectedRowKeys: Array<any>;


  onSelectChange(selectedRowKeys) {
    this.$emit('onSelectChange',selectedRowKeys)
  }
  
  findUser(value){
    const user = this.employeesList.find(res => res.id === value)
    return user ? user.name : ""
  }

  findDept(value){
    const dept = this.listAllTree.find(res => res.key === value)
    return dept ? dept.title : ""
  }

  handleTableChange(current: number, pageSize: number) {
    const pager = {
      pageSize: pageSize,
      current: current
    }
    this.$emit('handleTableChange', pager)
  }
  
  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  clickRow(record){
    this.$emit('clickRow', record.id)
  }

  render() {
    return (
      <div id="dataOutOrder-body">
        <ml-table
          pagination={false}
          columns={this.columns}
          dataSource={this.data}
          bordered
          rowKey="id"
          selectRowKey={this.selectId}
          loading={this.loading}
          scroll={{ y: this.height, x: 1600 }}
          row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange }}
          customRow={(record) => {
            return {
              on: { // 事件
                click: () => this.clickRow(record),       // 点击行
              },
            };
          }}
        >
        </ml-table>
        <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          show-total={total => `${ this.showTotal(total) }`}
          current={ this.current }
          pageSize={ this.pageSize }
          total={ this.total }
          on-change={ this.handleTableChange }
          on-showSizeChange={ this.handleTableChange }
        />
      </div>
    )
  }
}